import styled from 'styled-components';
import StyledCheckbox from '../checkbox/StyledCheckbox';
import SortingIcon from '../svgIcons/SortingIcon';
import StyledToolTip from '../styledComponents/StyledToolTip';
import InfoIcon from '../svgIcons/InfoIcon';

const TableHeader = ({
  sortColumn,
  checkBox,
  setSelectedRows,
  selectedRows,
  columns,
  data,
  onSort,
  handleSelectAll,
  formListings,
  type = ''
}) => {
  const raiseSort = (path) => {
    if (!path) return;
    const sort = { ...sortColumn };
    if (sort.path === path)
      sort.order = sortColumn.order === 'ASC' ? 'DESC' : 'ASC';
    else {
      sort.path = path;
      sort.order = 'ASC';
    }
    onSort(sort);
  };

  const renderSortIcon = (column) => {
    if (column.path !== sortColumn.path) return null;
    if (column.path === 'hired') return null;
    if (sortColumn.order === 'DESC') return <SortingIcon />;
    return <SortingIcon rotate="up" />;
  };

  return (
    <THead>
      <tr>
        {checkBox &&  (
          <th style={{ width: '15px' }}>
            
            {!formListings &&<StyledTableCheck
              // className={`ms-2 mb-1 me-2`}
              size={15}
              value={selectedRows.length === data.length}
              onChange={handleSelectAll}
            />}
          </th>
        )}
        {columns?.map((column) => (
          <th
            style={{ width: column.width }}
            className={column.alignHeader}
            key={Math.random()}
            onClick={() => onSort && raiseSort(column.path)}
          >
             {column.label} {renderSortIcon(column)}
             {column?.tooltip ? <StyledToolTip title={column?.tooltip} childrenClass={'ms-1'} applyStyle={false}><InfoIcon size='13'/></StyledToolTip> : null}
            
          </th>
        ))}
      </tr>
    </THead>
  );
};

const THead = styled.thead`
  --bs-table-bg: ${({ theme }) => theme.tableHeaderBg};
  --bs-table-color: ${({ theme }) => theme.onHeader};
  color: ${({ theme }) => theme.onHeader};
  background-color: ${({ theme }) => theme.tableHeaderBg} !important;

  th {
    font-size: 13px;
    font-weight: ${({ theme }) => theme.fontWeightSemibold};
    color: ${({ theme }) => theme.onHeader} !important;
    background-color: ${({ theme }) => theme.tableHeaderBg} !important;
    padding: 12px 16px;
    white-space: nowrap;
    border: none;
    vertical-align: middle;

    /* Column titles often wrap StyledLabel (headingColor / black). Force
       on-navy ink so light and dark both stay readable. */
    label,
    span,
    p,
    a,
    div {
      color: inherit !important;
    }

    /* Header is flush with the top and sides of the parent box. */
    &:first-child {
      border-radius: ${({ theme }) => `${theme.radiusCard} 0 0 0`};
    }

    &:last-child {
      border-radius: ${({ theme }) => `0 ${theme.radiusCard} 0 0`};
    }

    svg {
      color: currentColor;
    }

    svg [stroke]:not([stroke='none']) {
      stroke: currentColor;
    }

    svg [fill]:not([fill='none']) {
      fill: currentColor;
    }
  }
`;

const StyledTableCheck = styled(StyledCheckbox)`
   margin: 8px;
   margin-bottom:10px;
   margin-top: 0px
`;

export default TableHeader;